import Cookie from 'js-cookie';

import {
  FALL_BACK,
  getAppCookieDomainToClearTokens,
  getCookie,
  getCookieAttrubutes,
  setCookie
} from '../AccountsStorageUtils';

const COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY = 'n67h8d7rk7';
const COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY = 'n67h8d7erk';

export const getCollegePredictorAccessToken = () => {
  return getCookie(COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY);
};

export const getCollegePredictorRefreshToken = () => {
  return getCookie(COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY);
};

export const setCollegePredictorAccessTokenToDomain = (
  accessToken: string,
  expiryInDays = 30
) => {
  setCookie(COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY, accessToken, expiryInDays);
};

export const setCollegePredictorRefreshTokenToDomain = (
  refreshToken: string,
  expiryInDays = 30
) => {
  setCookie(COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY, refreshToken, expiryInDays);
};

const clearCollegePredictorDomainAccessToken = (domain?: string) => {
  Cookie.remove(COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain,
    sameSite: 'None'
  });
  Cookie.remove(`${COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY}_${FALL_BACK}`, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

const clearCollegePredictorDomainRefreshAccessToken = (domain?: string) => {
  Cookie.remove(COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain,
    sameSite: 'None'
  });
  Cookie.remove(`${COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY}_${FALL_BACK}`, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearCollegePredictorDomainTokens = () => {
  const appCookieDomain = getAppCookieDomainToClearTokens();
  if (appCookieDomain) {
    clearCollegePredictorDomainAccessToken(appCookieDomain);
    clearCollegePredictorDomainRefreshAccessToken(appCookieDomain);
  }
};

export const clearAllCollegePredictorDomainTokens = () => {
  clearCollegePredictorDomainTokens();
  clearCollegePredictorDomainAccessToken();
  clearCollegePredictorDomainRefreshAccessToken();
};
